import { Injectable, Injector, Type } from '@angular/core';

import { TBotItem } from '@core/interfaces/TBotItem';

import { AgentStrategyInterface } from './agent-strategy.interface';

@Injectable({ providedIn: 'root' })
export class AgentStrategyManagerService {
  private currentStrategy?: AgentStrategyInterface;

  private loaders: Record<string, () => Promise<Type<AgentStrategyInterface>>> = {
    agent: () => import('./strategies/default-strategy').then(m => m.DefaultStrategy),
    quiz: () => import('./strategies/quiz-strategy').then(m => m.QuizStrategy),
  };

  constructor(private injector: Injector) {}

  async setStrategy(agent?: TBotItem): Promise<AgentStrategyInterface> {
    let loader: (() => Promise<Type<AgentStrategyInterface>>) | undefined;

    const type = agent?.type || null;

    switch (type) {
      case 'quizBot':
        loader = this.loaders.quiz;
        break;
      default:
        loader = this.loaders.agent;
        break;
    }

    if (!loader) {
      throw new Error(`No strategy for "${type}"`);
    }

    const StrategyClass = await loader();

    this.currentStrategy = this.injector.get<AgentStrategyInterface>(
      StrategyClass as Type<AgentStrategyInterface>
    );

    return this.currentStrategy;
  }

  get strategy(): AgentStrategyInterface {
    if (!this.currentStrategy) {
      throw new Error('No strategy set');
    }
    return this.currentStrategy;
  }
  getStrategyOrNull(): AgentStrategyInterface | null {
    return this.currentStrategy || null;
  }
}
